export default __webpack_public_path__ + "static/media/P-009.7eefec9c.png";